module.exports = require('./helpers/bundle-url').getBundleURL('h1yBP') + "logo.c51670a8.svg";